module.exports = __webpack_public_path__ + "static/media/logo-final.bfa63822.jpg";